<template>
  <div class="details-backdrop" @click.self="$emit('close')">
    <section class="details-panel" role="dialog" aria-modal="true" aria-labelledby="record-details-title">
      <header class="details-header">
        <div>
          <p class="details-label">记录详情</p>
          <h2 id="record-details-title">{{ title }}</h2>
        </div>
        <button ref="closeButton" type="button" class="close-button" aria-label="关闭详情" title="关闭详情" @click="$emit('close')">
          <van-icon name="cross" aria-hidden="true" />
        </button>
      </header>
      <div class="details-body"><slot /></div>
    </section>
  </div>
</template>

<script>
import { Icon } from 'vant'
import 'vant/lib/icon/index.css'

export default {
  name: 'RecordDetails',
  components: { 'van-icon': Icon },
  props: {
    title: { type: String, required: true }
  },
  mounted () {
    this.previousFocus = document.activeElement
    this.previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    window.addEventListener('keydown', this.handleKeydown)
    this.$refs.closeButton.focus()
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
    document.body.style.overflow = this.previousOverflow
    if (this.previousFocus && document.contains(this.previousFocus)) this.previousFocus.focus()
  },
  methods: {
    handleKeydown (event) {
      if (event.key === 'Escape') {
        this.$emit('close')
      } else if (event.key === 'Tab') {
        const focusable = [...this.$el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])')]
        if (!focusable.length) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (event.shiftKey && (document.activeElement === first || !this.$el.contains(document.activeElement))) {
          event.preventDefault()
          last.focus()
        } else if (!event.shiftKey && (document.activeElement === last || !this.$el.contains(document.activeElement))) {
          event.preventDefault()
          first.focus()
        }
      }
    }
  }
}
</script>

<style scoped>
.details-backdrop { position: fixed; inset: 0; z-index: 30; display: flex; align-items: center; justify-content: center; padding: 24px; background: rgba(20, 39, 43, .38); }
.details-panel { display: flex; flex-direction: column; width: min(680px, 100%); max-height: min(760px, calc(100vh - 48px)); border-radius: 8px; background: #fff; box-shadow: 0 18px 55px rgba(15, 40, 44, .2); overflow: hidden; }
.details-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; flex: none; padding: 25px 30px 22px; border-bottom: 1px solid #e2e9e6; }
.details-label { margin: 0 0 7px; color: #6c8887; font-size: 12px; }
h2 { margin: 0; color: #18333a; font-size: 21px; line-height: 1.4; }
.close-button { display: grid; flex: none; width: 34px; height: 34px; place-items: center; border: 0; border-radius: 5px; color: #687e80; background: #f3f6f5; cursor: pointer; font-size: 18px; }
.close-button:hover { color: #1f7168; background: #e7f2ee; }
.details-body { min-height: 0; padding: 25px 30px 32px; overflow-y: auto; }
@media (max-width: 640px) {
  .details-backdrop { align-items: center; padding: 16px; }
  .details-panel { width: 100%; max-height: calc(100vh - 32px); border-radius: 7px; }
  .details-header { padding: 21px 20px 18px; }
  .details-body { padding: 20px 20px 28px; }
}
</style>
